// components/LoadingScreen.js
import { Box, CircularProgress, Typography } from "@mui/material";
import Logo from "../assets/logo.png"; // din OceanLogix-logo

export default function LoadingScreen({
  message = "eSign by OceanLogix is loading your document to sign...",
  fullHeight = true,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={fullHeight ? "100vh" : "auto"}
      width="100%"
      textAlign="center"
      px={2}
      gap={3}
      sx={{
        background: "linear-gradient(to bottom right, #7AB2D3, #b3e5fc)",
      }}
    >
      <Box mb={2}>
        <img src={Logo} alt="OceanLogix" style={{ width: 160 }} />
      </Box>
      <CircularProgress size={70} thickness={5} sx={{ color: "#ffffff" }} />
      <Typography
        variant="h6"
        color="common.white"
        sx={{ mt: 2, maxWidth: 400 }}
      >
        {message}
      </Typography>
    </Box>
  );
}
